module.exports = __webpack_public_path__ + "static/49-seat-coach-hire-interior-152d855cdb574f3faf2e0fe073dacd25.jpg";